import { useIsPairClose } from '@ui/features/RWA/hooks/useIsPairClose';
import { SleepIndicator } from '@ui/features/RWA/SleepIndicator';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { Text } from '@ui/lib/park/ui/text';
import { HStack, HstackProps, styled } from 'styled-system/jsx';

export const TokenPair = (p: HstackProps) => {
  const tradingPair = useTradingPair((v) => v.useTradingPair());
  const isPairSleeping = useIsPairClose(tradingPair);

  return (
    <HStack gap={2} {...p}>
      <styled.img src={tradingPair?.image} boxSize="24px" borderRadius="full" />
      <Text
        fontSize="15px"
        fontWeight={600}
        color="v2.text.primary"
        whiteSpace="nowrap"
      >
        {tradingPair.baseName}
      </Text>
      {isPairSleeping && <SleepIndicator />}
    </HStack>
  );
};
